import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const chatCreate = async (
  userIds: string[],
  accessToken: string,
  type = "single"
) => {
  const bodyParams = {
    members: userIds,
    accessToken: accessToken,
    type: type,
  };

  return apiClient(endpoints.chat.chatCreate, {
    method: "POST",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchAllChats = async (accessToken: string) => {
  const bodyParams = { accessToken };

  return apiClient(endpoints.Chat.fetchUserChatList, {
    method: "POST",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchChatHistory = async (accessToken: string, chatId: string) => {
  const bodyParams = { chatId, accessToken };

  return apiClient(endpoints.Chat.fetchChatHistory, {
    method: "POST",
    body: JSON.stringify({ body: bodyParams }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const CreateNewChat = async (
  userIds: string[],
  accessToken: string,
  type = "single"
) => {
  const bodyParams = {
    members: userIds,
    accessToken,
    type,
  };

  return apiClient(endpoints.Chat.createChat, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserChatList = async (
  accessToken: string,
  conversationId: String,
  messagePopup: boolean
) => {
  const bodyParams = { accessToken, conversationId, messagePopup };

  return apiClient(endpoints.Chat.fetchUserChatList, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchChatHistoryID = async (
  accessToken: string,
  chatId: string
) => {
  const bodyParams = { chatId, accessToken };

  return apiClient(endpoints.Chat.fetchChatHistory, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserStatus = async (accessToken: string) => {
  const bodyParams = { accessToken };

  return apiClient(endpoints.Chat.fetchUserStatus, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const AddMemberInChat = async (
  accessToken: string,
  conversationId: string,
  userIds: string[]
) => {
  const bodyParams = {
    accessToken,
    conversationId,
    members: userIds,
  };

  return apiClient(endpoints.Chat.addMember, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const DeleteChat = async (accessToken: string, chatId: string) => {
  const bodyParams = {
    accessToken,
    chatId,
  };

  return apiClient(endpoints.Chat.deleteChat, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
